import DashboardIcon from '@mui/icons-material/Dashboard'
import AssessmentIcon from '@mui/icons-material/Assessment'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import CategoryIcon from '@mui/icons-material/Category'
import VideoCallIcon from '@mui/icons-material/VideoCall'
import { ISchool } from '../../../interfaces/school.interface'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'

export type IStudentTeacherDashboardSidebar = Array<
  IStudentTeacherDashboardSidebarItem
>

export interface IStudentTeacherDashboardSidebarItem {
  icon: any
  label: string
  link: string
  hasDivider: boolean
  children?: Array<IStudentTeacherDashboardSidebarItem>
  hide: boolean
}

export const student_teacher_dashboard_sidebar = (
  userType: 'student' | 'teacher',
  _schoolDetails: ISchool,
): Array<IStudentTeacherDashboardSidebarItem> => {
  const sidebar = [
    {
      icon: DashboardIcon,
      label: 'My courses',
      link: `/dashboard`,
      hasDivider: false,
      hide: false,
    },
    {
      icon: CategoryIcon,
      label: 'Categories',
      link: `/categories`,
      hasDivider: false,
      hide: false,
    },
    {
      icon: AssessmentIcon,
      label: 'Quizzes',
      link: `/assessments`,
      hasDivider: false,
      hide: false,
    },
    // {
    //   icon: ChatBubbleIcon,
    //   label: 'Active Chats',
    //   link: `/user-chat`,
    //   hasDivider: false,
    //   hide: !schoolDetails?.show_active_chats,
    // },
    // {
    //   icon: PeopleIcon,
    //   label: 'Community',
    //   link: `/discussion`,
    //   hasDivider: false,
    //   hide: !schoolDetails.show_forum,
    // },
    {
      icon: VideoCallIcon,
      label: 'Live class',
      link: `/schedules`,
      hasDivider: false,
      hide: false,
    },
    {
      icon: WorkspacePremiumIcon,
      label: 'Certificates',
      link: `/student-certificate`,
      hasDivider: false,
      hide: false,
    },
    {
      icon: CreditCardIcon,
      label: 'Billing',
      link: `/student-billing`,
      hasDivider: false,
      hide: !['student'].includes(userType),
    },
  ]

  return sidebar.filter(s => !s.hide)
}
